const isKatakana = (str: string) => {
    return !!str.match(/^[ァ-ヶー　]*$/);
}

export {isKatakana}